import { render } from "./ModalUpdateRRIM.vue?vue&type=template&id=1cffbe86&scoped=true"
import script from "./ModalUpdateRRIM.vue?vue&type=script&lang=js"
export * from "./ModalUpdateRRIM.vue?vue&type=script&lang=js"

import "./ModalUpdateRRIM.vue?vue&type=style&index=0&id=1cffbe86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cffbe86"]])

export default __exports__